module.exports = __webpack_public_path__ + "static/img/brees-2006-slide-8.15b9160.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2006-slide-8.jpg
// module id = pnl4
// module chunks = 1